$( document ).ready(function() {
  
  $("button.form-submit").on('click', function() {
    var fname = $('.contactFormName').val();
    var mail = $('.contactFormEmail').val();
    var password = $('.contactFormMessage').val();
    
    if (fname  == '' && mail == '' && password == '') {
      if (fname == '') {
        $('.error').removeClass('hide');
      } else {
        $('.error').addClass('hide');
      }
      if (mail == '') {
        $('.error').removeClass('hide');
      } else {
        $('.error').addClass('hide');
      }
      if (password == '') {
        $('.error').removeClass('hide');
      } else {
        $('.error').addClass('hide');
      }
      
      return false;
    }
    
  });
  
  
  $("#vehicle1").on('click', function() {
    var ckb_status = $("#vehicle1")
    if(ckb_status.is(':checked')) {
      console.log('checked')
      $('.form-submit').removeAttr('disabled');
    } else {
      console.log('unchecked')
      $('.form-submit').attr('disabled','disabled');
    }
    
  });
});